export default {"src":"/_next/static/media/cards-icon-2.cb931cb9.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};